import { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";

const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ value, setValue ] = useState(items.length === 1 && items[0]?.priceInfo?.price || null)
  const { account, selectedStore, updateItem, exchangeRates, storeCurrency } = useContext(AuthContext);
  let retailCurrency = items[0]?.priceInfo?.retailPriceCurrency || storeCurrency
  let costCurrency = items[0]?.priceInfo?.currency || storeCurrency
  const retailCurrencyToCostCurrencyRate = exchangeRates[retailCurrency].rate / exchangeRates[costCurrency].rate


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Price', { items: items.length })
    let bulk_update = []

    items.forEach((item) => {
      let priceInfoDefaults = {
        quantity: 0,
        price: 0,
        retailPrice: 0,
        markup: 0,
        currency: account.acctStores[selectedStore].currency,
        retailPriceCurrency: account.acctStores[selectedStore].currency,
      }

      let priceInfo = {
        ...priceInfoDefaults,
        ...item.priceInfo
      }

      priceInfo.price = parseFloat(formatter.format(value))

      if (priceInfo.markup) {
        let newPrice = priceInfo.price
        let newRetailPrice = newPrice * retailCurrencyToCostCurrencyRate * priceInfo.markup
        priceInfo.retailPrice = parseFloat(formatter.format(newRetailPrice))
      }

      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          {
            priceInfo
          },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Cost Price</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Price</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change pricing of all of your selected items
          </DialogContentText>
          {/*  */}
          <TextField
            variant='standard'
            label=""
            value={value}
            onChange={(e) => { setValue(e.target.value.replace(/[a-zA-Z\,]/, '.')) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}